export const formattedHistory = (past_rollovers, t) => {
    const rolloverHistory = past_rollovers
      ? JSON.parse(past_rollovers)
      : {};
  
    return Object.entries(rolloverHistory)
      .map(([year, days]) => t("calendar.rollover_days_info", { var1: year, var2: days, var3: days === 1 ? '' : 's' }))
      .join('<br />');
  };
  